import React from 'react';

const FooterFooter = () => {
  return (
    <div className="footer_section footer-footer">
      <div className="container">
        <div className="footer-logo">
          <svg className="icon -footer-logo">
            <use xlinkHref="#svg_verizon-long-branded" />
          </svg>
        </div>
        <div className="footer-right-part">
          <ul>
            <li>
              <span>Privacy Policy</span>
            </li>
            <li>
              <span>California Privacy Notice</span>
            </li>
            <li>
              <span>Health Privacy Notice</span>
            </li>
            <li>
              <span>
                Your Privacy Choices
                <svg className="svg-icon icon-privacy-choices">
                  <use xlinkHref={ `#svg_privacy-choices` } />
                </svg>
              </span>
            </li>
            <li>
              <span>Accessibility</span>
            </li>
            <li>
              <span>Open Internet</span>
            </li>
            <li>
              <span>Terms & Conditions</span>
            </li>
            <li>
              <span>About Our Ads</span>
            </li>
          </ul>
          <div className="copyright-section">© 2025 Verizon</div>
        </div>
      </div>
    </div>
  );
};

export default FooterFooter;
